// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.permission-modal .ant-select-selector .user-avatar-tag {
  display: flex;
  align-items: center;
}
.permission-modal .ant-select-selector .user-avatar-tag .user-avatar {
  display: flex;
  align-items: center;
}
.permission-modal .ant-select-selector .user-avatar-tag .user-avatar .user-avatar-image {
  margin-right: 10px;
  height: 25px;
  width: 25px;
}
.permission-modal .ant-select-selector .user-avatar-tag .user-avatar div.user-avatar-name {
  display: flex;
  flex-direction: column;
}
.permission-modal .ant-select-selector .user-avatar-tag .user-avatar div.user-avatar-name > span:first-child {
  margin-right: 5px;
  font-weight: unset;
}
.permission-modal .ant-select-selector .user-avatar-tag .user-avatar div.user-avatar-name > span:nth-of-type(2) {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/Component/FormField/Permission/UserPermissionGrid/UserPermissionGrid.less"],"names":[],"mappings":"AAAA;EAEI,aAAA;EACA,mBAAA;AAAJ;AAHA;EAMM,aAAA;EACA,mBAAA;AAAN;AAPA;EAUQ,kBAAA;EACA,YAAA;EACA,WAAA;AAAR;AAZA;EAgBQ,aAAA;EACA,sBAAA;AADR;AAhBA;EAoBU,iBAAA;EACA,kBAAA;AADV;AApBA;EAyBU,aAAA;AAFV","sourcesContent":[".permission-modal {\n  .ant-select-selector .user-avatar-tag {\n    display: flex;\n    align-items: center;\n\n    .user-avatar {\n      display: flex;\n      align-items: center;\n\n      .user-avatar-image {\n        margin-right: 10px;\n        height: 25px;\n        width: 25px;\n      }\n\n      div.user-avatar-name {\n        display: flex;\n        flex-direction: column;\n\n        > span:first-child {\n          margin-right: 5px;\n          font-weight: unset;\n        }\n\n        > span:nth-of-type(2) {\n          display: none;\n        }\n      }\n    }\n  }\n}\n\n@drawer-width: 600px;@primary-color: #137CBD;@info-color: #137CBD;@success-color: #0F9960;@warning-color: #D9822B;@error-color: #DB3737;@link-color: #137CBD;@font-size-base: 14px;@heading-color: rgba(0, 0, 0, 0.85);@text-color: rgba(0, 0, 0, 0.65);@text-color-secondary: rgba(0, 0, 0, .45);@disabled-color: rgba(0, 0, 0, .25);@border-radius-base: 0px;@border-color-base: #d9d9d9;@box-shadow-base: 0 2px 8px rgba(0, 0, 0, 0.15);"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
